import { render, staticRenderFns } from "./itinerary-updatedMessage.vue?vue&type=template&id=15ff7fa9"
import script from "./itinerary-updatedMessage.vue?vue&type=script&lang=js"
export * from "./itinerary-updatedMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports